import Vue from 'vue'
import Router from 'vue-router'
import main from '@/layout'
import seller from "@/layout/seller";

Vue.use(Router)
const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'main',
      redirect: '/index',
      component: main,
      children: [
        // 首页
        {
          path: 'index',
          name: 'index',
          component: () => import('@/views/home')
        },
        // 分类
        {
          path: 'mallCategory',
          name: 'mallCategory',
          component: () => import('@/views/category')
        },
        // 货源市场
        {
          path: 'market',
          name: 'market',
          component: () => import('@/views/market')
        },
        {
          path: 'brand',
          name: 'brand',
          component: () => import('@/views/brand')
        },
        // 我的
        {
          path: 'mine',
          name: 'mine',
          component: () => import('@/views/mine')
        }
        ,{
          path: '/message',
          name: 'message',
          component: () => import('@/views/message')
        },
      ]
    },
    //卖家中心
    {
      path: '/sellerCenter',
      name: 'seller',
      redirect: 'sellerCenter/sellerHome',
      component: seller,
      children: [
        // 卖家中心首页
        {
          path: 'sellerHome',
          name: 'sellerHome',
          component: () => import('@/views/sellerCenter/sellerHome')
        },
      ]
    },

    // 平台登录
    {
      path: '/platformLogin',
      name: 'platformLogin',
      component: () => import('@/views/platformLogin')
    },
    // 核销兑换码
    {
      path: '/welfare',
      name: 'welfare',
      component: () => import('@/views/platformLogin/welfare')
    },

    //财务
    {
      path: '/sellerCenter/finance',
      name: 'finance',
      component: () => import('@/views/sellerCenter/finance')
    },
    //财务-保证金
    {
      path: '/sellerCenter/finance/cashManagement',
      name: 'cashManagement',
      component: () => import('@/views/sellerCenter/finance/cashManagement')
    },
    //财务-提现管理
    {
      path: '/sellerCenter/finance/cashDeposit',
      name: 'cashDeposit',
      component: () => import('@/views/sellerCenter/finance/cashDeposit')
    },
    //财务-提现明细
    {
      path: '/sellerCenter/finance/cashDetail',
      name: 'cashDetail',
      component: () => import('@/views/sellerCenter/finance/cashDetail')
    },
    //报表
    {
      path: '/sellerCenter/report',
      name: 'report',
      component: () => import('@/views/sellerCenter/report')
    },
    //报表-商品销量统计
    {
      path: '/sellerCenter/report/commoditySales',
      name: 'commoditySales',
      component: () => import('@/views/sellerCenter/report/commoditySales')
    },
    //报表-商品访问统计
    {
      path: '/sellerCenter/report/goodsVisit',
      name: 'goodsVisit',
      component: () => import('@/views/sellerCenter/report/goodsVisit')
    },
    //卖家店铺订单
    {
      path: '/sellerCenter/sellerOrder',
      name: 'sellerOrder',
      component: () => import('@/views/sellerCenter/sellerOrder')
    },
    // 卖家订单搜索
    {
      path: '/sellerCenter/sellerOrder/sellerOrderSearch',
      name: 'sellerOrderSearch',
      component: () => import('@/views/sellerCenter/sellerOrder/sellerOrderSearch')
    },
    // 卖家订单搜索结果
    {
      path: '/sellerCenter/sellerOrder/sellerSearchResult',
      name: 'sellerSearchResult',
      component: () => import('@/views/sellerCenter/sellerOrder/sellerSearchResult')
    },
    // 卖家商品销量
    {
      path: '/sellerCenter/goodsOrder/goodsSales',
      name: 'goodsSales',
      component: () => import('@/views/sellerCenter/goodsOrder/goodsSales')
    },
    // 卖家商品总数
    {
      path: '/sellerCenter/goodsOrder/goodsTotal',
      name: 'goodsTotal',
      component: () => import('@/views/sellerCenter/goodsOrder/goodsTotal')
    },
    //订单详情
    {
      path: '/sellerCenter/sellerOrder/sellerOrderDetail',
      name: 'sellerOrderDetail',
      component: () => import('@/views/sellerCenter/sellerOrder/sellerOrderDetail')
    },
    {
      path: '/sellerCenter/sellerOrder/sellerFregist',
      name: 'sellerFregist',
      component: () => import('@/views/sellerCenter/sellerOrder/sellerFregist')
    },
    {
      path: '/sellerCenter/sellerOrder/orderLogistics',
      name: 'orderLogistics',
      component: () => import('@/views/sellerCenter/sellerOrder/orderLogistics')
    },
    // 卖家订单总数
    {
      path: '/sellerCenter/goodsOrder/orderTotal',
      name: 'orderTotal',
      component: () => import('@/views/sellerCenter/goodsOrder/orderTotal')
    },
    //卖家商品分类
    {
      path: '/sellerCenter/sellerCategory',
      name: 'sellerCategory',
      component: () => import('@/views/sellerCenter/sellerCategory')
    },
    //子级分类详情
    {
      path: '/sellerCenter/sellerCategory/sellerChildCategory',
      name: 'sellerChildCategory',
      component: () => import('@/views/sellerCenter/sellerCategory/sellerChildCategory')
    },
    // 卖家活动培训
    {
      path: '/sellerCenter/sellerTrainingActivities',
      name: 'sellerTrainingActivities',
      component: () => import('@/views/sellerCenter/sellerTrainingActivities')
    },
    // 卖家活动培训详情
    {
      path: '/sellerCenter/sellerTrainingActivities/sellerTrainingDetail',
      name: 'sellerTrainingDetail',
      component: () => import('@/views/sellerCenter/sellerTrainingActivities/sellerTrainingDetail')
    },
    // 卖家新闻资讯
    {
      path: '/sellerCenter/sellerNews',
      name: 'sellerNews',
      component: () => import('@/views/sellerCenter/sellerNews')
    },
    // 卖家新闻资讯详情
    {
      path: '/sellerCenter/sellerNewsDetail',
      name: 'sellerNewsDetail',
      component: () => import('@/views/sellerCenter/sellerNews/sellerNewsDetail')
    },
    // 卖家意见反馈
    {
      path: '/sellerCenter/sellerFeedback',
      name: 'sellerFeedback',
      component: () => import('@/views/sellerCenter/sellerFeedback')
    },
    // 卖家登录
    {
      path: '/sellerCenter/sellerLogin',
      name: 'sellerLogin',
      component: () => import('@/views/sellerCenter/sellerLogin')
    },
    // 进货单
    {
      path: '/purchase',
      name: 'purchase',
      component: () => import('@/views/purchase/index')
    },
    // 进货单-拼货商品
    {
      path: '/purchaseLcl',
      name: 'purchaseLcl',
      component: () => import('@/views/purchase/lcl')
    },
    // 注册
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/login/register')
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login')
    },
    // 手机登录
    {
      path: '/phoneLogin',
      name: 'phoneLogin',
      component: () => import('@/views/login/phoneLogin')
    },
    // 忘记密码
    {
      path: '/findPassword',
      name: 'findPassword',
      component: () => import('@/views/login/findPassword')
    },
    // 绑定页面
    {
      path: '/bindPage',
      name: 'bindPage',
      component: () => import('@/views/login/bindPage')
    },
    // 子级分类
    {
      path: '/category',
      name: 'childCategory',
      component: () => import('@/views/category/childCategory')
    },
    //采购商品
    {
      path: '/caigou',
      name: 'caigouCategory',
      component: () => import('@/views/category/caigouCategory')
    },
    // 热门分类
    {
      path: '/hotCategory',
      name: 'hotCategory',
      component: () => import('@/views/category/hotCategory')
    },
    // 全部分类
    {
      path: '/allCategory',
      name: 'allCategory',
      component: () => import('@/views/category/allCategory')
    },
    // 搜索
    {
      path: '/search',
      name: 'search',
      component: () => import('@/views/search')
    },
    // 搜索商品
    {
      path: '/searchGoods',
      name: 'searchGoods',
      component: () => import('@/views/search/searchGoods')
    },
    // 搜索商品
    {
      path: '/searchImage',
      name: 'searchImage',
      component: () => import('@/views/search/searchImage')
    },
    // 搜索供应商
    {
      path: '/searchSuppliers',
      name: 'searchSuppliers',
      component: () => import('@/views/search/searchSuppliers')
    },
    // 找货必看
    {
      path: '/recommendGoods',
      name: 'recommendGoods',
      component: () => import('@/views/recommendGoods')
    },
    // 新品上架
    {
      path: '/newArrival',
      name: 'newGoods',
      component: () => import('@/views/newGoods')
    },
    // 跨境专区商品
    {
      path: '/crossBorderZone',
      name: 'crossBorderZone',
      component: () => import('@/views/crossBorderZone')
    },
    // 品牌专区
    {
      path: '/brandZone',
      name: 'brandZone',
      component: () => import('@/views/brandZone')
    },
    // 视频专区分类
    {
      path: '/videoZone',
      name: 'videoZone',
      redirect: '/videoZone/videoGoods',
      component: () => import('@/views/videoZone/index'),
      children: [
        {
          path: 'videoCategory',
          name: 'videoCategory',
          component: () => import('@/views/videoZone/videoCategory')
        },
        {
          path: 'videoGoods',
          name: 'videoGoods',
          component: () => import('@/views/videoZone/videoGoods')
        }
      ]
    },
    // 活动模板分类
    {
      path: '/activityCategory',
      name: 'activityCategory',
      component: () => import('@/views/activityTemplate/activityCategory')
    },
    // 活动模板商品
    {
      path: '/activityGoods',
      name: 'activityGoods',
      component: () => import('@/views/activityTemplate/activityGoods')
    },
    // 活动模板规则
    {
      path: '/activityRules',
      name: 'activityRules',
      component: () => import('@/views/activityTemplate/activityRules')
    },
    // 活动培训
    {
      path: '/trainingActivities',
      name: 'trainingActivities',
      component: () => import('@/views/trainingActivities')
    },
    // 活动培训详情
    {
      path: '/trainingDetail',
      name: 'trainingDetail',
      component: () => import('@/views/trainingActivities/trainingDetail')
    },
    // 活动确认
    {
      path: '/scan',
      name: 'scan',
      component: () => import('@/views/trainingActivities/scan')
    },
    {
      path: '/qrcode',
      name: 'qrcode',
      component: () => import('@/views/trainingActivities/qrcode')
    },
    // 活动培训详情
    {
      path: '/signDetail',
      name: 'signDetail',
      component: () => import('@/views/trainingActivities/signDetail')
    },
    // 抽奖活动
    {
      path: '/draw',
      name: 'draw',
      component: () => import('@/views/drawActivity/draw')
    },
    // 营销活动
    {
      path: '/newActivity',
      name: 'newActivity',
      component: () => import('@/views/newActivity')
    },
    // 促销活动
    {
      path: '/promotion',
      name: 'promotion',
      redirect: '/promotion/seckill',
      component: () => import('@/views/promotion/index'),
      children: [
        {
          path: 'seckill',
          name: 'seckill',
          component: () => import('@/views/promotion/seckill')
        }, {
          path: 'moneyOff',
          name: 'moneyOff',
          component: () => import('@/views/promotion/moneyOff')
        },
        {
          path: 'coupon',
          name: 'coupon',
          component: () => import('@/views/promotion/coupon')
        }, {
          path: 'lcl',
          name: 'lcl',
          component: () => import('@/views/promotion/lcl')
        }
      ]
    },
    // 分类
    {
      path: '/promotionCategory',
      name: 'promotionCategory',
      component: () => import('@/views/promotion/promotionCategory')
    },
    // 店铺
    {
      path: '/shop/shopIndex',
      name: 'shop',
      component: () => import('@/views/shop/index')
    },
    // 店铺分类
    {
      path: '/shopCategory',
      name: 'shopCategory',
      component: () => import('@/views/shop/shopCategory')
    },
    // 店铺活动
    {
      path: '/shopActivites',
      name: 'shopActivites',
      redirect: '/shopActivites/shopSeckill',
      component: () => import('@/views/shop/shopActivites'),
      children: [
        {
          path: 'shopSeckill',
          name: 'shopSeckill',
          component: () => import('@/views/shop/shopSeckill')
        },
        {
          path: 'shopMoneyOff',
          name: 'shopMoneyOff',
          component: () => import('@/views/shop/shopMoneyOff')
        },
        {
          path: 'shopCoupon',
          name: 'shopCoupon',
          component: () => import('@/views/shop/shopCoupon')
        }
      ]
    },
    //品牌中心
    {
      path: '/brandShop',
      name: 'brandShop',
      component: () => import('@/views/brand/brandShop')
    },
    {
      path: '/brandGoods',
      name: 'brandGoods',
      component: () => import('@/views/brand/brandGoods')
    },
    // 店铺申请分销
    {
      path: '/applyDistributor',
      name: 'applyDistributor',
      component: () => import('@/views/shop/applyDistributor')
    },
    // 店铺联系我们
    {
      path: '/shopContact',
      name: 'shopContact',
      component: () => import('@/views/shop/shopContact')
    },
    // 商品详情
    {
      path: '/shop/goodsDetail',
      name: 'goodsDetail',
      component: () => import('@/views/goodsDetail')
    },
    // 商品评价
    {
      path: '/goodsEvaluate',
      name: 'goodsEvaluate',
      component: () => import('@/views/goodsDetail/goodsEvaluate')
    },
    // 订单结算
    {
      path: '/orderSettle',
      name: 'orderSettle',
      component: () => import('@/views/orderSettle')
    },
    {
      path: '/useCoupon',
      name: 'useCoupon',
      component: () => import('@/views/orderSettle/useCoupon')
    },
    // 收银台
    {
      path: '/cashierDesk',
      name: 'cashierDesk',
      component: () => import('@/views/cashierDesk')
    },
    // 支付成功
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: () => import('@/views/paySuccess')
    },
    // 订单管理
    {
      path: '/order',
      name: 'order',
      component: () => import('@/views/order/index')
      // children: [
      //   {
      //     path: 'waitPayment',
      //     name: 'waitPayment',
      //     component: () => import('@/views/order/waitPayment')
      //   },
      //   {
      //     path: 'waitGroups',
      //     name: 'waitGroups',
      //     component: () => import('@/views/order/waitGroups')
      //   },
      //   {
      //     path: 'waitDelivery',
      //     name: 'waitDelivery',
      //     component: () => import('@/views/order/waitDelivery')
      //   },
      //   {
      //     path: 'waitReceive',
      //     name: 'waitReceive',
      //     component: () => import('@/views/order/waitReceive')
      //   },
      //   {
      //     path: 'successfulDeals',
      //     name: 'successfulDeals',
      //     component: () => import('@/views/order/successfulDeals')
      //   },
      //   {
      //     path: 'closedDeals',
      //     name: 'closedDeals',
      //     component: () => import('@/views/order/closedDeals')
      //   },
      //   {
      //     path: 'waitEvaluation',
      //     name: 'waitEvaluation',
      //     component: () => import('@/views/order/waitEvaluation')
      //   },
      //   {
      //     path: 'recycle',
      //     name: 'recycle',
      //     component: () => import('@/views/order/recycle')
      //   }
      // ]
    },
    // 订单搜索
    {
      path: '/orderSearch',
      name: 'orderSearch',
      component: () => import('@/views/order/orderSearch')
    },
    // 订单搜索结果
    {
      path: '/searchResult',
      name: 'searchResult',
      component: () => import('@/views/order/searchResult')
    },
    // 订单评价
    {
      path: '/orderRate',
      name: 'orderRate',
      component: () => import('@/views/order/orderRate')
    },
    // 订单追踪
    {
      path: '/orderLogistics',
      name: 'orderLogistics',
      component: () => import('@/views/order/orderLogistics')
    },
    // 订单详情
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/order/orderDetail')
    },
    // 拼货详情
    {
      path: '/groupDetail',
      name: 'groupDetail',
      component: () => import('@/views/order/groupDetail')
    },
    // 会员升级
    {
      path: '/membershipUpgrade',
      name: 'membershipUpgrade',
      component: () => import('@/views/membershipUpgrade')
    },
    // 会员升级购买
    {
      path: '/membershipPay',
      name: 'membershipPay',
      component: () => import('@/views/membershipUpgrade/membershipPay')
    },
    // 会员账号-资金中心
    {
      path: '/fundsManagement',
      name: 'fundsManagement',
      component: () => import('@/views/fundsManagement/moneyCenter')
    },
    // 提现明细
    {
      path: '/drawMoney',
      name: 'drawMoney',
      component: () => import('@/views/fundsManagement/drawMoney')
    },
    // 充值账户
    // {
    //   path: '/recharge',
    //   name: 'recharge',
    //   component: () => import('@/views/recharge')
    // },
    // 在线充值
    // {
    //   path: '/onlineRecharge',
    //   name: 'onlineRecharge',
    //   component: () => import('@/views/recharge/onlineRecharge')
    // },
    // 我的积分
    {
      path: '/integral',
      name: 'integral',
      component: () => import('@/views/integral')
    },
    {
      path: '/returnAfter',
      name: 'returnAfter',
      component: () => import('@/views/afterSale/returnAfter')
    },
    {
      path: '/afterFregist',
      name: 'afterFregist',
      component: () => import('@/views/afterSale/modules/afterFregist')
    },
    {
      path: '/afterApplication',
      name: 'afterApplication',
      component: () => import('@/views/afterSale/afterApplication')
    },
    {
      path: '/application',
      name: 'application',
      component: () => import('@/views/afterSale/application')
    },
    {
      path: '/applyDetail',
      name: 'applyDetail',
      component: () => import('@/views/afterSale/applyDetail')
    },
    {
      path: '/serviceProgress',
      name: 'serviceProgress',
      component: () => import('@/views/afterSale/serviceProgress')
    },
    // 供应商-分销合作管理
    {
      path: '/distribution',
      name: 'distribution',
      redirect: '/distribution/cooperation',
      component: () => import('@/views/distribution/index'),
      children: [
        // 合作中
        {
          path: 'cooperation',
          name: 'cooperation',
          component: () => import('@/views/distribution/cooperation')
        },
        // 邀约中
        {
          path: 'invite',
          name: 'invite',
          component: () => import('@/views/distribution/invite')
        },
        // 申请中
        {
          path: 'applyFor',
          name: 'applyFor',
          component: () => import('@/views/distribution/applyFor')
        },
        // 已终止
        {
          path: 'terminated',
          name: 'terminated',
          component: () => import('@/views/distribution/terminated')
        }
      ]
    },
    // 商品收藏
    {
      path: '/goodsCollection',
      name: 'goodsCollection',
      component: () => import('@/views/goodsCollection')
    },
    // 店铺收藏
    {
      path: '/shopCollect',
      name: 'shopCollect',
      component: () => import('@/views/shopCollect')
    },
    // 浏览足迹
    {
      path: '/browseFootprint',
      name: 'browseFootprint',
      component: () => import('@/views/browseFootprint')
    },
    // 我的优惠券
    {
      path: '/discountCoupon',
      name: 'discountCoupon',
      redirect: '/discountCoupon/availableCoupon',
      component: () => import('@/views/discountCoupon/index'),
      children: [
        // 可用优惠券
        {
          path: 'availableCoupon',
          name: 'availableCoupon',
          component: () => import('@/views/discountCoupon/availableCoupon')
        },
        // 回收站
        {
          path: 'recycleBin',
          name: 'recycleBin',
          component: () => import('@/views/discountCoupon/recycleBin')
        }

      ]
    },
    // 个人信息
    {
      path: '/personalInfo',
      name: 'personalInfo',
      component: () => import('@/views/personalInfo')
    }
    ,{
      path: '/settle',
      name: 'settle',
      component: () => import('@/views/settle')
    },
    // 我的推广
    {
      path: '/generalize',
      name: 'generalize',
      component: () => import('@/views/generalize')
    },
    // 推广数据
    {
      path: '/promoteData',
      name: 'promoteData',
      redirect: '/promoteData/invitation',
      component: () => import('@/views/promoteData/index'),
      children: [
        // 邀请
        {
          path: 'invitation',
          name: 'invitation',
          component: () => import('@/views/promoteData/invitation')
        },
        // 获得分佣
        {
          path: 'commission',
          name: 'commission',
          component: () => import('@/views/promoteData/commission')
        }
      ]
    },
    // 新闻资讯
    {
      path: '/news',
      name: 'news',
      component: () => import('@/views/news')
    },
    // 新闻资讯详情
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: () => import('@/views/news/newsDetail')
    },
    // 帮助中心
    {
      path: '/help',
      name: 'help',
      component: () => import('@/views/help')
    },
    // 帮助中心详情
    {
      path: '/helpDetail',
      name: 'helpDetail',
      component: () => import('@/views/help/helpDetail')
    },
    // 意见反馈
    {
      path: '/feedback',
      name: 'feedback',
      component: () => import('@/views/feedback')
    },
    // 账号设置
    {
      path: '/accountSettings',
      name: 'accountSettings',
      component: () => import('@/views/accountSettings')
    },
    // 快捷登录
    {
      path: '/quickLogin',
      name: 'quickLogin',
      component: () => import('@/views/quickLogin')
    },
    // 收货地址管理
    {
      path: '/address',
      name: 'address',
      component: () => import('@/views/address')
    },
    // 新建收货地址
    {
      path: '/address/newAddress',
      name: 'newAddress',
      component: () => import('@/views/address/newAddress')
    },
    // 临时收货地址
    {
      path: '/address/temporaryAddress',
      name: 'temporaryAddress',
      component: () => import('@/views/address/temporaryAddress')
    },
    // 修改电话
    {
      path: '/modifyPhone',
      name: 'modifyPhone',
      component: () => import('@/views/modifyPhone')
    },
    // 修改头像
    {
      path: '/modifyHeadPortrait',
      name: 'modifyHeadPortrait',
      component: () => import('@/views/modifyHeadPortrait')
    },
    // 修改密码
    {
      path: '/changePassword',
      name: 'changePassword',
      component: () => import('@/views/changePassword')
    },
    // 账户实名
    {
      path: '/identityVerification',
      name: 'identityVerification',
      component: () => import('@/views/identityVerification')
    },
    // 领取兑换码
    {
      path: '/redeemCode',
      name: 'redeemCode',
      component: () => import('@/views/redeemCode')
    },
    // 查看兑换码
    {
      path: '/receiveCode',
      name: 'receiveCode',
      component: () => import('@/views/redeemCode/receiveCode')
    },

  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js